import type { RootState } from '~/store';

export const clanStarsSelector = (state: RootState) => state.ReducerClanStars;

export const clanStarsAccountRewardsSelector = (state: RootState) => state.ReducerClanStars.accountRewards;
export const clanStarsSelectedTabSelector = (state: RootState) => state.ReducerClanStars.selectedTab;
